import { render, staticRenderFns } from "./capability1.vue?vue&type=template&id=4a60dc8c&scoped=true&"
var script = {}
import style0 from "./capability1.vue?vue&type=style&index=0&id=4a60dc8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a60dc8c",
  null
  
)

export default component.exports